package com.kinoshazam.model

enum class ThemeState {
    DARK,
    LIGHT,
    SYSTEM;

    companion object {
        fun fromName(name: String?): ThemeState =
            ThemeState.entries.find { it.name == name } ?: SYSTEM
    }
}